import { render, staticRenderFns } from "./ViewHolidays.vue?vue&type=template&id=2cb7b032&scoped=true"
import script from "./ViewHolidays.vue?vue&type=script&lang=js"
export * from "./ViewHolidays.vue?vue&type=script&lang=js"
import style0 from "./ViewHolidays.vue?vue&type=style&index=0&id=2cb7b032&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7b032",
  null
  
)

export default component.exports